import { AlertTriangle } from 'lucide-react'
import { missingEnvKeys } from '@/lib/env'
import { AuthShell } from './auth-shell'

export function SetupScreen() {
  return (
    <AuthShell
      title="Configuração necessária"
      subtitle="Falta conectar o Supabase para o app funcionar."
    >
      <div className="space-y-4 text-sm">
        <div className="flex items-start gap-3 rounded-xl border border-warning/30 bg-warning/10 p-3">
          <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0 text-warning" />
          <p>
            Defina as variáveis de ambiente e recarregue. Copie{' '}
            <code className="rounded bg-muted px-1">.env.example</code> para{' '}
            <code className="rounded bg-muted px-1">.env.local</code>.
          </p>
        </div>
        <div>
          <p className="mb-1 font-medium">Variáveis faltando:</p>
          <ul className="list-inside list-disc text-muted-foreground">
            {missingEnvKeys.length ? (
              missingEnvKeys.map((k) => (
                <li key={k}>
                  <code className="rounded bg-muted px-1">{k}</code>
                </li>
              ))
            ) : (
              <li>Verifique a URL do Supabase (deve começar com https://).</li>
            )}
          </ul>
        </div>
        <p className="text-xs text-muted-foreground">
          Instruções completas no <code className="rounded bg-muted px-1">README.md</code> (seção
          "Configurar o Supabase").
        </p>
      </div>
    </AuthShell>
  )
}
